import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class StateCultureListService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	searchStateCulture(token, descricaoCultura, estado, status, orderby, sort, page) {

		var statusFilter = "";
		if (status != "") statusFilter = "and Ativo eq " + status;

		var estadoFilter ="";
		if (estado != "") estadoFilter = "and EstadoID eq guid'" + estado + "'";


		page = page * globalConst.paginationSkip;

		return this.http
		.get(this.apiUrl + "stateculture/v1/getculturestate?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=startswith(tolower(Cultura/Descricao),'" + descricaoCultura.toLowerCase() + "') " + estadoFilter + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/stateculture/service/stateculture-list/stateculture-list.service.ts